import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import {
  checkRequired,
  validateElectricalLicenseNumber,
  validateExpiryDate,
  validateFile,
} from "pages/formTools";
import { Vendor } from "../..";

// Resolves the language per call, so messages follow the switcher.
const ta = i18n.getFixedT(null, "auth");

export const validateSignature = (data: Vendor): FieldErrorMap => ({
  offeringEvInstallation: checkRequired(
    ta("fields.installation_services"),
    data.offeringEvInstallation,
    ta("fields.installation_required"),
  ),

  province: checkRequired(
    ta("fields.province"),
    data.province,
    ta("fields.province_required"),
  ),

  // Only required from vendors who offer installation.
  electricalLicense:
    data.offeringEvInstallation === "Yes"
      ? validateFile({
          name: ta("fields.electrical_license"),
          file: data.electricalLicense,
          required: true,
          allowedTypes: ["pdf", "image/*"],
          maxSizeMB: 10,
          errorMessage: ta("common.invalid_file"),
        })
      : null,

  // Same rule as the licence itself — only vendors who install need one.
  electricalLicenseNumber:
    data.offeringEvInstallation === "Yes"
      ? validateElectricalLicenseNumber({
          name: ta("fields.license_number"),
          value: data.electricalLicenseNumber ?? "",
          required: true,
          errorMessage: ta("fields.license_digits"),
        })
      : null,

  electricalLicenseExpiryDate:
    data.offeringEvInstallation === "Yes"
      ? validateExpiryDate({
          name: ta("fields.license_expiry"),
          value: data.electricalLicenseExpiryDate,
          required: true,
        })
      : null,
});
